import moment from 'moment-timezone';

import {CONSTANTS} from '../index';

export const utcToTimezone = (date?: string, timezone?: string, isOrdinal = false) => {
  if (!timezone || !date) return date;
  const timeInTimezone = moment.utc(date).tz(timezone);
  return timeInTimezone.format(isOrdinal ? CONSTANTS.ordinal_date_format : CONSTANTS.main_date_format);
};
